import { Component, inject } from '@angular/core';
import {LayoutService} from "../../shared/services/layout.service";
import {FormBuilder, FormGroup} from '@angular/forms';
import {IconBadgeComponent} from "../../shared/elements/icon-badge/icon-badge.component";
import {TranslatePipe} from "../../shared/pipes/translate.pipe";
import {HeadlineComponent} from "../../shared/elements/headline/headline.component";
import {ContentComponent} from "../../shared/elements/content/content.component";
import {FormButtonComponent} from "../../shared/elements/form-button/form-button.component";
import {FormLabelComponent} from "../../shared/elements/form-label/form-label.component";
import {FormRadioComponent} from "../../shared/elements/form-radio/form-radio.component";
import {FormTextareaComponent} from "../../shared/elements/form-textarea/form-textarea.component";
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

@Component({
    selector: 'app-feedback-display-sd',
    imports: [
        TranslatePipe,
        IconBadgeComponent,
        HeadlineComponent,
        ContentComponent,
        FormButtonComponent,
        FormLabelComponent,
        FormRadioComponent,
        FormTextareaComponent,
        NgSrcImageErrorDirective
    ],
    templateUrl: './feedback-display-sd.component.html',
    styleUrl: './feedback-display-sd.component.scss'
})
export class FeedbackDisplaySdComponent {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);

  isVisibleQuestion = true;
  startFeedback(){

  }
  /**** FORM GROUP */
  public feedbackForm: FormGroup = this.formBuilder.group({
    radio_options: [''],
    feedback_comment: ['']
  });
}
